import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getAnalyticsConsent, setAnalyticsConsent } from '../utils/analytics';

function CookieConsent() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getAnalyticsConsent();
    if (!consent && window.__GA_ID) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setAnalyticsConsent('accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    setAnalyticsConsent('declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-label={t('cookies.title')}>
      <p className="cookie-consent__text">{t('cookies.message')}</p>
      <div className="cookie-consent__actions">
        <button type="button" className="btn btn-ghost" onClick={handleDecline}>
          {t('cookies.decline')}
        </button>
        <button type="button" className="btn btn-primary" onClick={handleAccept}>
          {t('cookies.accept')}
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;
